const Email = value => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)

const TrillAcceptedEmail = value => /^[^@\s]+@((yahoo|trill)-corp|dely).jp$/i.test(value)

export { Email, TrillAcceptedEmail }
